// User Roles
export const ROLES = {
  SUPERADMIN: 'superadmin',
  CONTRACTOR: 'contractor',
  ENGINEER: 'engineer',
  CONSULTANT: 'consultant',
  SUPPLIER: 'supplier',
};

// User Types
export const USER_TYPES = {
  MAIN_CONTRACTOR: 'main-contractor',
  SUB_CONTRACTOR: 'sub-contractor',
  BOTH_CONTRACTOR: 'both-contractor',
  INSPECTION_ENGINEER: 'inspection-engineer',
  QUANTIFICATION_ENGINEER: 'quantification-engineer',
  BOTH_ENGINEER: 'both-engineer',
};

// User Statuses
export const USER_STATUSES = {
  PENDING: 'pending',
  REJECTED: 'rejected',
  SUSPENDED: 'suspended',
};

// Service Categories
export const SERVICE_CATEGORIES = [
  'Concrete',
  'Plumbing',
  'Electrical',
  'HVAC',
  'Roofing',
  'Painting',
  'Flooring',
  'Carpentry',
  'Metal Works',
  'Landscaping',
  'Joinery',
  'Earth Works',
];

// Navigation items for each role
export const NAVIGATION = {
  [ROLES.SUPERADMIN]: [
    { name: 'Dashboard', path: '/superadmin', icon: 'HomeIcon' },
    { name: 'User Approvals', path: '/superadmin/approvals', icon: 'CheckCircleIcon' },
    { name: 'License Management', path: '/superadmin/license-management', icon: 'DocumentTextIcon' },
    { name: 'Contractors', path: '/superadmin/contractors', icon: 'UsersIcon' },
    { name: 'Engineers', path: '/superadmin/engineers', icon: 'WrenchScrewdriverIcon' },
    { name: 'Consultants', path: '/superadmin/consultants', icon: 'BriefcaseIcon' },
    { name: 'Customers', path: '/superadmin/customers', icon: 'UserGroupIcon' },
    { name: 'Suppliers', path: '/superadmin/suppliers', icon: 'BuildingStorefrontIcon' },
    { name: 'Featured Providers', path: '/superadmin/featured-providers', icon: 'StarIcon' },
    { name: 'Quotes & Bookings', path: '/superadmin/quotes-bookings', icon: 'DocumentTextIcon' },
    { name: 'Orders & Payments', path: '/superadmin/orders', icon: 'ClipboardDocumentListIcon' },
    { name: 'Ad Posts', path: '/superadmin/ads', icon: 'MegaphoneIcon' },
    {
      name: 'Content Management',
      icon: 'MegaphoneIcon',
      group: true,
      children: [
        { name: 'Offers', path: '/superadmin/offers', icon: 'GiftIcon' },
        { name: 'Materials', path: '/superadmin/ContentManagement', icon: 'ClipboardDocumentListIcon' },
      ],
    },
    { name: 'Settings', path: '/superadmin/settings', icon: 'Cog6ToothIcon' },
  ],
  [ROLES.CONTRACTOR]: [
    { name: 'Dashboard', path: '/service-provider', icon: 'HomeIcon' },
    { name: 'Requested Quotes', path: '/service-provider/invitations', icon: 'CheckCircleIcon' },
    { name: 'Submitted Quotes', path: '/service-provider/quotes', icon: 'DocumentTextIcon' },
    { name: 'Post Ads', path: '/service-provider/ads', icon: 'MegaphoneIcon' },
    { name: 'Work Summary', path: '/service-provider/work-summary', icon: 'ChartBarIcon' },
    { name: 'Suppliers', path: '/service-provider/supplier', icon: 'UserGroupIcon' },
    { name: 'Orders', path: '/service-provider/orders', icon: 'ClipboardDocumentListIcon' },
    { name: 'My Account', path: '/service-provider/profile', icon: 'UserIcon' },
  ],
  [ROLES.CONSULTANT]: [
    { name: 'Dashboard', path: '/service-provider', icon: 'HomeIcon' },
    { name: 'Requested Quotes', path: '/service-provider/invitations', icon: 'CheckCircleIcon' },
    { name: 'Submitted Quotes', path: '/service-provider/quotes', icon: 'DocumentTextIcon' },
    { name: 'Post Ads', path: '/service-provider/ads', icon: 'MegaphoneIcon' },
    { name: 'Work Summary', path: '/service-provider/work-summary', icon: 'ChartBarIcon' },
    { name: 'My Account', path: '/service-provider/profile', icon: 'UserIcon' },
  ],
  [ROLES.ENGINEER]: [
    { name: 'Dashboard', path: '/service-provider', icon: 'HomeIcon' },
    { name: 'Requested Quotes', path: '/service-provider/invitations', icon: 'CheckCircleIcon' },
    { name: 'Submitted Quotes', path: '/service-provider/quotes', icon: 'DocumentTextIcon' },
    { name: 'Post Ads', path: '/service-provider/ads', icon: 'MegaphoneIcon' },
    { name: 'Work Summary', path: '/service-provider/work-summary', icon: 'ChartBarIcon' },
    { name: 'Payments', path: '/service-provider/payments', icon: 'CurrencyDollarIcon' },
    { name: 'My Account', path: '/service-provider/profile', icon: 'UserIcon' },
  ],
  [ROLES.SUPPLIER]: [
    { name: 'Dashboard', path: '/supplier', icon: 'HomeIcon' },
    { name: 'Requests', path: '/supplier/requests', icon: 'ClipboardDocumentListIcon' },
    // { name: 'Quotations', path: '/supplier/quotations', icon: 'DocumentTextIcon' },
    { name: 'Orders Placed', path: '/supplier/orders', icon: 'BriefcaseIcon' },
    // { name: 'Payments', path: '/supplier/payments', icon: 'CurrencyDollarIcon' },
    { name: 'My Account', path: '/supplier/profile', icon: 'UserCircleIcon' },
  ],
};

// Quote statuses
export const QUOTE_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  EXPIRED: 'expired',
};

// Engineer types
export const ENGINEER_TYPES = {
  INSPECTION: 'inspection',
  QUANTIFICATION: 'quantification',
  BOTH: 'both',
};
